import React, { Fragment, FunctionComponent } from 'react';
import { useTranslation } from '@rbx/intl';
import { Grid, Typography } from '@rbx/ui';
import CodeSamples from '@modules/ui/shared/components/CodeSamples';
import useHeadingGroupStyles from '@modules/ui/shared/styles/HeadingGroup.styles';
import { itemsID } from '../../constants/apiReferenceConstants';
import APIReferenceDescription from '../../sharedUI/components/APIReferenceDescription';
import { EnumReference } from '../../types';
import EnumCharacteristicsIterator from './EnumCharacteristicsIterator';
import EnumItemsTable from './EnumItemsTable';

export interface EnumContentProps {
  enumReference: EnumReference;
  engineRevampEnabled?: boolean;
}

const EnumContent: FunctionComponent<React.PropsWithChildren<EnumContentProps>> = ({
  enumReference: { name, description, codeSamples, deprecationMessage, items, tags },
  engineRevampEnabled = false,
}) => {
  const { translate } = useTranslation();
  const {
    classes: { root },
  } = useHeadingGroupStyles();

  if (engineRevampEnabled) {
    return (
      <div className={root}>
        <APIReferenceDescription name={name} description={description} engineRevampEnabled />
        {items && items.length > 0 && (
          <Fragment>
            <Typography variant='h2' component='div' style={{ marginBottom: '24px' }}>
              {translate('Label.Items') || 'Items'}
            </Typography>
            <EnumItemsTable items={items} />
          </Fragment>
        )}
        {Array.isArray(codeSamples) && codeSamples.length > 0 && (
          <div style={{ marginTop: '24px' }}>
            <CodeSamples codeSamples={codeSamples} />
          </div>
        )}
      </div>
    );
  }
  return (
    <Grid className={root} container direction='column'>
      <Grid item XSmall>
        <Grid container direction='column'>
          <Grid item XSmall>
            <APIReferenceDescription
              name={name}
              description={description}
              deprecationMessage={deprecationMessage}
              tags={tags}
            />
            <Typography variant='h2' component='h2' id={itemsID}>
              {translate('Label.Items') || 'Items'}
            </Typography>
            {items && <EnumCharacteristicsIterator enumItems={items} />}
            {Array.isArray(codeSamples) && codeSamples.length > 0 ? (
              <CodeSamples codeSamples={codeSamples} />
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default EnumContent;
